import {


    CORE_GET_ALL_TABLE_REQUEST,
    CORE_GET_ALL_TABLE_SUCCESS,
    CORE_GET_ALL_TABLE_FAILURE,

    CORE_GET_TABLE_BY_ID_REQUEST,
    CORE_GET_TABLE_BY_ID_SUCCESS,
    CORE_GET_TABLE_BY_ID_FAILURE,

    CORE_SET_WORKER_REQUEST,
    CORE_SET_WORKER_SUCCESS,
    CORE_SET_WORKER_FAILURE,

    CORE_SET_START_TIME_REQUEST,
    CORE_SET_START_TIME_SUCCESS,
    CORE_SET_START_TIME_FAILURE,

    CORE_SET_END_TIME_REQUEST,
    CORE_SET_END_TIME_SUCCESS,
    CORE_SET_END_TIME_FAILURE,

    CORE_TASK_ON_JOB_REQUEST,
    CORE_TASK_ON_JOB_SUCCESS,
    CORE_TASK_ON_JOB_FAILURE,

    CORE_REPORT_AS_FINISHED_DATAS_REQUEST,
    CORE_REPORT_AS_FINISHED_DATAS_SUCCESS,
    CORE_REPORT_AS_FINISHED_DATAS_FAILURE,

    REQUEST_STATE
} from '../types'

const requestState = REQUEST_STATE

export default {
    getTables: (state = requestState, action) => {
        switch (action.type) {
            case CORE_GET_ALL_TABLE_REQUEST:
                return state
            case CORE_GET_ALL_TABLE_SUCCESS:
                if (action.payload) {
                    const { result, datas } = action.payload
                    if (result && datas) {
                        return datas
                    }
                    return []
                } else return []
            case CORE_GET_ALL_TABLE_FAILURE:
                return []
            default:
                return state
        }
    },
    getTable: (state = requestState, action) => {
        switch (action.type) {
            case CORE_GET_TABLE_BY_ID_REQUEST:
                return state
            case CORE_GET_TABLE_BY_ID_SUCCESS:
                if (action.payload && !Array.isArray(action.payload) && typeof action.payload === "object") {
                    const { result, data } = action.payload
                    if (result && data) {
                        return data
                    }
                    return {}
                } else return {}
            case CORE_GET_TABLE_BY_ID_FAILURE:
                return {}
            default:
                return state
        }
    },
    pdsmAxData: (state = requestState, action) => {
        switch (action.type) {
            case CORE_TASK_ON_JOB_REQUEST:
                return state
            case CORE_TASK_ON_JOB_SUCCESS:
                if (action.payload && !Array.isArray(action.payload) && typeof action.payload === "object") {
                    const { result, data } = action.payload
                    console.log(action.payload)
                    if (result && data) {
                        return data
                    }
                    return {}
                } else return {}
            case CORE_TASK_ON_JOB_FAILURE:
                return {}
            default:
                return state
        }
    },
    setStartTime: (state = requestState, action) => {
        switch (action.type) {
            case CORE_SET_START_TIME_REQUEST:
                return state
            case CORE_SET_START_TIME_SUCCESS:
                if (action.payload && !Array.isArray(action.payload) && typeof action.payload === "object") {
                    const { result, data } = action.payload
                    if (result && data) {
                        return data
                    }
                    return {}
                } else return {}
            case CORE_SET_START_TIME_FAILURE:
                return {}
            default:
                return state
        }
    },
    setEndTime: (state = requestState, action) => {
        switch (action.type) {
            case CORE_SET_END_TIME_REQUEST:
                return state
            case CORE_SET_END_TIME_SUCCESS:
                if (action.payload && !Array.isArray(action.payload) && typeof action.payload === "object") {
                    const { result, data } = action.payload
                    if (result && data) {
                        return data
                    }
                    return {}
                } else return {}
            case CORE_SET_END_TIME_FAILURE:
                return {}
            default:
                return state
        }
    },
    setWorker: (state = requestState, action) => {
        switch (action.type) {
            case CORE_SET_WORKER_REQUEST:
                return state
            case CORE_SET_WORKER_SUCCESS:
                if (action.payload && !Array.isArray(action.payload) && typeof action.payload === "object") {
                    const { result, data } = action.payload
                    if (result && data) {
                        return data
                    }
                    return {}
                } else return {}
            case CORE_SET_WORKER_FAILURE:
                return {}
            default:
                return state
        }
    },
    reportFinishData: (state = requestState, action) => {
        switch (action.type) {
            case CORE_REPORT_AS_FINISHED_DATAS_REQUEST:
                return state
            case CORE_REPORT_AS_FINISHED_DATAS_SUCCESS:
                if (action.payload) {
                    const { result, datas } = action.payload
                    if (result && datas) {
                        return datas
                    }
                    return []
                } else return []
            case CORE_REPORT_AS_FINISHED_DATAS_FAILURE:
                return []
            default:
                return state
        }
    },

}



// WEBPACK FOOTER //
// ./src/app/redux/reducers/display.js